import styled from 'styled-components';

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding-top: 0.5rem;
`;

export const SectionTitle = styled.h4`
  font-size: 1rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  border-bottom: 1px solid #f1f5f9;

  svg {
    color: #3b82f6;
  }
`;

export const FormRow = styled.div`
  display: flex;
  gap: 1rem;

  @media (max-width: 500px) {
    flex-direction: column;
  }
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 0.4rem;
`;

export const Label = styled.label`
  font-size: 0.85rem;
  font-weight: 600;
  color: #475569;
`;

export const RequiredMark = styled.span`
  color: #ef4444;
  margin-left: 2px;
`;

export const ReadOnlyText = styled.div`
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  padding: 8px 12px;
  border-radius: 6px;
  color: #64748b;
  font-weight: 500;
`;

export const ToggleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
`;

export const ServicesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;
